import dayjs from "dayjs";

/**
 * Real play data exists for this booking. Mirrors the legacy "Game state" checkmark,
 * which keyed on play data (minutes/score) — NOT on the `finished` flag.
 */
export function hasPlayData(booking) {
    return (Number(booking?.minutes_played) || 0) > 5 || (Number(booking?.score) || 0) > 0;
}

/**
 * Booking lifecycle badge, shared by the bookings table and the detail page.
 *
 * "Played" and "Finished" are BOTH green on purpose: a game that was actually played
 * but whose end-of-game processing has not set `finished` yet must not read as a problem.
 * Keying the badge on `finished` alone made such bookings show "Not finished" and alarmed
 * operators; the legacy "Game state" mark keyed on play data, which this restores.
 *
 * Order matters: deleted → scheduled (future) → finished → played → not played.
 */
export function getBookingStatus(booking, now = dayjs()) {
    if (!booking) {
        return { key: "unknown", label: "", cls: "" };
    }
    if (booking.deleted_at) {
        return { key: "deleted", label: "Deleted", cls: "badge-fout" };
    }
    if (dayjs(booking.date).isAfter(now)) {
        return { key: "scheduled", label: "Scheduled", cls: "badge-info" };
    }
    if (booking.finished) {
        return { key: "finished", label: "Finished", cls: "badge-goed" };
    }
    if (hasPlayData(booking)) {
        return { key: "played", label: "Played", cls: "badge-goed" };
    }
    return { key: "not-played", label: "Not played", cls: "badge-letop" };
}
